import _, { map } from 'underscore';
import React, { useContext, useEffect, useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import { withCustomValidation } from '@bingads-webui-react/validation';
import { RecommendationContext } from '@bingads-webui-campaign-react/perf-max-recommendation';
import { TextAssetCollectionWithRecommendations, getTextAssetCollectionConfig, getTextAssetCollectionConfigByFeature } from '@bingads-webui-campaign-react/pmax-text-input';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { PermissionsContext } from '@bingads-webui-react/hoc-with-permissions';

const HeadlinesWithRecommendationPrefillInternal = (props) => {
  const {
    currentData,
    withInlineRecommendations,
    updateValidation,
    isAudienceAd,
  } = props;
  const i18n = useContext(I18nContext);
  const permissions = useContext(PermissionsContext);
  const textAssetCollectionConfig = useMemo(() => getTextAssetCollectionConfigByFeature({ featureName: 'displayPlus' }), []);

  const headlineConfig = useMemo(() => getTextAssetCollectionConfig('headlines', i18n, textAssetCollectionConfig), [i18n, textAssetCollectionConfig]);
  const [recommendationContext] = useContext(RecommendationContext);

  const headlinesRecommendationText = useMemo(() =>
    recommendationContext && recommendationContext.headlines && map(recommendationContext.headlines, rec => rec.Text), [recommendationContext]);
  const [prevHeadlineRecommendation, setPrevHeadlineRecommendation] = useState();

  useEffect(() => {
    if (headlinesRecommendationText && _.isArray(headlinesRecommendationText) && !_.isEmpty(headlinesRecommendationText) &&
      currentData && currentData.Headline0 === '') {
      if (prevHeadlineRecommendation &&
          (headlinesRecommendationText[0] === prevHeadlineRecommendation[0])) {
        return;
      }

      setPrevHeadlineRecommendation(headlinesRecommendationText);
      currentData.Headline0 = (headlinesRecommendationText && headlinesRecommendationText[0]) || '';
      updateValidation([], {
        Headlines: currentData,
      });
    }
  }, [prevHeadlineRecommendation, headlinesRecommendationText, currentData, updateValidation]);

  return (
    <TextAssetCollectionWithRecommendations
      {...headlineConfig}
      validationProps={{
        data: {
          Headlines: currentData,
        },
      }}
      isOptional={false}
      showDeleteButton
      i18n={i18n}
      withInlineRecommendations={withInlineRecommendations}
      updateValidation={updateValidation}
      enableCopilotRecommendations={permissions.dynamic.DisplayPlusCopilotRecommendations}
      isAudienceAd={isAudienceAd}
    />
  );
};

HeadlinesWithRecommendationPrefillInternal.propTypes = {
  cancelFetchRecommendationAssetsJob: PropTypes.func.isRequired,
  fetchRecommendationAssets: PropTypes.func.isRequired,
  withInlineRecommendations: PropTypes.bool.isRequired,
  currentData: PropTypes.shape({
    Headline0: PropTypes.string,
    Headline1: PropTypes.string,
  }).isRequired,
  textAssetConfig: PropTypes.shape({
    descriptions: PropTypes.shape({}),
  }).isRequired,
  updateValidation: PropTypes.func.isRequired,
  isAudienceAd: PropTypes.bool,
};

HeadlinesWithRecommendationPrefillInternal.defaultProps = {
  isAudienceAd: false,
};

export const HeadlinesWithRecommendationPrefill = withCustomValidation(HeadlinesWithRecommendationPrefillInternal);
